// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { File } from "le-coffre-resources/dist/SuperAdmin";
import type { QueryPayload } from "../../../types";
import type { IGetFilesparams } from "./Files";
import {
	createGetMethod,
	createGetByUidMethod,
	createDeleteMethod,
	createDownloadMethod,
	createDownloadMultipleMethod,
	createDownloadAggregatedCertificateMethod,
} from "./helpers/filesNotaryMethodsHelpers";

interface FilesNotaryInstance {
	get(q: IGetFilesparams): Promise<File[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<File>;
	delete(uid: string): Promise<File>;
	download(uid: string): Promise<Blob>;
	downloadMultiple(fileUids: string[], includeAnchors?: boolean, folderNumber?: string, folderName?: string): Promise<Blob>;
	downloadAggregatedCertificate(documentUids: string[], folderUid: string): Promise<Blob>;
}

// Module-level singleton instance
let instance: FilesNotaryInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createFilesNotary(): FilesNotaryInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const baseUrl = baseNotary.namespaceUrl.concat("/files-notary");

	return {
		get: createGetMethod(baseNotary, baseUrl),
		getByUid: createGetByUidMethod(baseNotary, baseUrl),
		delete: createDeleteMethod(baseNotary, baseUrl),
		download: createDownloadMethod(baseNotary, baseUrl),
		downloadMultiple: createDownloadMultipleMethod(baseNotary, baseUrl),
		downloadAggregatedCertificate: createDownloadAggregatedCertificateMethod(baseNotary, baseUrl),
	};
}

export function getFilesNotaryInstance(): FilesNotaryInstance {
	if (!instance) {
		instance = createFilesNotary();
	}
	return instance;
}
